import { configureStore } from "@reduxjs/toolkit";
import auth from "./slice/auth";
import cities from "./slice/cities";
import dashboard from "./slice/dashboard";
import general from "./slice/general";
import languages from "./slice/languages";
import onboarding from "./slice/onboarding";
import orders from "./slice/orders";
import services from "./slice/services";
import support from "./slice/support";
import users from "./slice/users";

export const store = configureStore({
  reducer: {
    services,
    dashboard,
    cities,
    users,
    general,
    orders,
    onboarding,
    languages,
    support,
    auth,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
